//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EscapeKey from "quasar/src/utils/escape-key";

export default {
    name: "QFabricModal",
    props: {
        atId: String,
        value: Boolean,
        contentClasses: String,
        footer: { type: Boolean, required: false, default: true },
        color: { type: String, required: false, default: "white" },
        size: { type: String, required: false, default: "720px" },
        "text-color": { type: String, required: false, default: "black" },
        title: { type: String, required: false, default: "" },
        save: { type: [Boolean, Object], required: false, default: false },
        create: { type: [Boolean, Object], required: false, default: false },
        clear: { type: [Boolean, Object], required: false, default: false },
        test: { type: [Boolean, Object], required: false, default: false },
        cancel: { type: [Boolean, Object], required: false, default: true },
        close: { type: [Boolean, Object], required: false, default: true },
        action: { type: Object, required: false },
        actions: { type: Array, required: false, default: () => [] },
        setPosition: { type: String, required: false, default: "right" },
        headerActions: { type: Boolean, required: false, default: false },
        isDisabled: { type: Boolean, required: false, default: false },
        dottedBtnDisabled: { type: Boolean, required: false, default: false },
        optionDisabled: { type: Boolean, required: false, default: false },
        headerActionsModel: { type: Array, required: false, default: () => [] },
        setCloseIcon: { type: String, required: false },
        noReverseTitle: { type: Boolean, required: false, default: false },
        shake: { type: Boolean, required: false, default: false },
        hideScroll: { type: Boolean, required: false, default: false },
        hasCheckbox: { type: Boolean, required: false, default: false },
        hasCancelDownloadBtns: { type: Boolean, required: false, default: false },
        disableDownload: { type: Boolean, required: false, default: true },
        isTestDisabled: { type: Boolean, required: false, default: false },
        longTouchModel: { type: Array, required: false, default: () => [] },
        fullWidthFooterBtn: { type: Boolean, required: false, default: false },
        noBackdropDismiss: { type: Boolean, default: false },
        darkMode: { type: Boolean, default: false }
    },
    data() {
        return {
            defaults: {
                close: { icon: "close", iconRight: "keyboard_arrow_right", iconLeft: "keyboard_arrow_left" },
                save: { label: this.$t("generic.save"), color: "primary", "text-color": "white" },
                create: { label: this.$t("generic.create"), color: "primary", "text-color": "white" },
                clear: { label: this.$t("generic.clear"), "text-color": "#2C3543" },
                test: { label: this.$t("generic.test"), "text-color": "black" },
                cancel: { label: this.$t("generic.cancel"), "text-color": "primary" },
                action: { color: "primary", "text-color": "white" }
            },
            createMore: false,
            showActive: false,
            showMenu: false
        };
    },
    computed: {
        getSuccessAtId() {
            return this.atId ? `${this.atId}-modalActionButton` : "multiPurposeButtonId";
        },
        getCloseAtId() {
            return this.atId ? `${this.atId}-modalCloseButton` : "closeModalButtonId";
        },
        getCheckboxAtId() {
            return this.atId ? `${this.atId}-modal-checkbox` : "modal-checkbox-id";
        },
        getCancelAtId() {
            return this.atId ? `${this.atId}-modal-cancel` : "modal-cancel-id";
        },
        getDownloadAtId() {
            return this.atId ? `${this.atId}-modal-download` : "modal-download-id";
        },
        moreOptions() {
            return this.atId ? `${this.atId}-modal-more-options` : "modal-more-options-id";
        },
        contentClass() {
            const def = ["qf-modal-custom"];
            if (this.contentClasses) {
                def.push(...this.contentClasses.split(" "));
            }

            return def;
        },
        contentCss() {
            return { height: "100%", "max-height": "unset", width: this.size, "max-width": "100vw" };
        },
        hasClose() {
            return this.close;
        },
        closeBtn() {
            const defaultIcon = this.setCloseIcon || (this.setPosition === "right" ? this.defaults.close.icon : this.defaults.close.iconRight);
            return typeof this.close === "object" && this.close.icon ? this.close.icon : defaultIcon;
        },
        hasSave() {
            return this.save;
        },
        hasCreate() {
            return this.create;
        },
        hasTest() {
            return this.test;
        },
        hasClearAll() {
            return this.clear;
        },
        hasHeaderActions() {
            return this.headerActions;
        },
        saveBtn() {
            const isObject = typeof this.save === "object";

            return {
                label: isObject && this.save.label ? this.save.label : this.defaults.save.label,
                color: isObject && this.save.color ? this.save.color : this.defaults.save.color,
                tooltip: isObject && this.save.tooltip ? this.save.tooltip : "",
                textColor: isObject && this.save["text-color"] ? this.save["text-color"] : this.defaults.save["text-color"]
            };
        },
        createBtn() {
            const isObject = typeof this.create === "object";

            return {
                label: isObject && this.create.label ? this.create.label : this.defaults.create.label,
                color: isObject && this.create.color ? this.create.color : this.defaults.create.color,
                textColor: isObject && this.create["text-color"] ? this.create["text-color"] : this.defaults.create["text-color"]
            };
        },
        testBtn() {
            const isObject = typeof this.test === "object";

            return {
                label: isObject && this.test.label ? this.test.label : this.defaults.test.label,
                textColor: isObject && this.test["text-color"] ? this.test["text-color"] : this.defaults.test["text-color"]
            };
        },
        clearAllBtn() {
            const isObject = typeof this.cancel === "object";

            return {
                label: isObject && this.clear.label ? this.clear.label : this.defaults.clear.label,
                textColor: isObject && this.clear["text-color"] ? this.clear["text-color"] : this.defaults.clear["text-color"]
            };
        },
        hasCancel() {
            return this.cancel;
        },
        cancelBtn() {
            const isObject = typeof this.cancel === "object";

            return {
                label: isObject && this.cancel.label ? this.cancel.label : this.defaults.cancel.label,
                textColor: isObject && this.cancel["text-color"] ? this.cancel["text-color"] : this.defaults.cancel["text-color"]
            };
        },
        getModalStyle() {
            return this.hideScroll ? "overflow:hidden" : "overflow-x: hidden";
        }
    },
    watch: {
        createMore: {
            handler(value) {
                this.$emit("checkboxModified", value);
            }
        },
        longTouchModel: {
            handler(value) {
                if (value && value.length) {
                    this.onHeaderMenuAction(value[0].id, value[0].index);
                }
            },
            immediate: true
        }
    },
    mounted() {
        // if (!this.shake) {
        //     this.$refs.qmodal.__shake = () => {};
        // }
        // this.$el.querySelector(".modal-backdrop").addEventListener("mousedown", this.onClickBackdrop);
    },
    beforeDestroy() {
        // this.$el.querySelector(".modal-backdrop").removeEventListener("mousedown", this.onClickBackdrop);
    },
    methods: {
        modalShow() {
            // this.addListener(true);
            this.$emit("afterShow");
        },
        modalHide() {
            // this.addListener(false);
            this.$emit("afterHide");
        },
        getActionStyle(action) {
            const defaultColor = this.action && this.action.hasOwnProperty("color") ? this.action.color : this.defaults.action.color;
            const defaultTextColor = this.action && this.action.hasOwnProperty("text-color") ? this.action["text-color"] : this.defaults.action["text-color"];

            return {
                color: action.hasOwnProperty("color") ? action.color : defaultColor,
                textColor: action.hasOwnProperty("text-color") ? action["text-color"] : defaultTextColor
            };
        },
        genericClick(actionName, simple) {
            this.$emit("action", { simple: simple ? "hide" : "action", detailed: actionName });
        },
        onClickClose() {
            this.genericClick("action_close", true);
        },
        onClickSave() {
            this.genericClick("action_save");
        },
        onClickCancel() {
            this.genericClick("action_cancel", true);
        },
        onClickClearAll() {
            this.genericClick("action_clear", true);
        },
        onClickDownload() {
            this.genericClick("action_download", true);
        },
        onClickTest() {
            this.genericClick("action_test", true);
        },
        onClickBackdrop() {
            this.genericClick("action_backdrop", true);
        },
        onClickAction(action) {
            this.genericClick(action.name);
        },
        closeModal() {
            this.$emit("input", false);
        },
        addListener(state) {
            if (state) {
                EscapeKey.register(() => {
                    this.genericClick("action_esc", true);
                });
            } else {
                EscapeKey.pop();
            }
        },
        onHeaderMenuAction(id, index) {
            if (!this.optionDisabled) {
                this.genericClick({ id, index });
                this.activeButton(false);
            }
        },
        activeButton(value) {
            this.showActive = !!value;
        },
        enableButton() {
            // eslint-disable-next-line vue/no-mutating-props
            this.disableDownload = false;
        },
        optionSelected(index) {
            return this.atId ? `${this.atId}-modal-option-${index}` : "modal-option-id";
        }
    }
};
